import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LeaderService } from 'src/app/leader-toolkit/services/leader.service';

@Component({
  selector: 'vc-reassign-task-modal',
  standalone: false,
  templateUrl: './reassign-task-modal.component.html',
  styleUrl: './reassign-task-modal.component.scss',
})
export class ReassignTaskModalComponent implements OnInit {


  reassignForm: FormGroup;
  userList: any[] = [];
  isLoading = false;
  hospitalData: number;
  taskTagDataUserlist: any;

  loading = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ReassignTaskModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { taskId: number; currentAssignee: string; taskTagDataUserlist?: any },
    public leaderService: LeaderService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getUserList();
    this.taskTagDataUserlist = this.data.taskTagDataUserlist || [];
  }

  onAssigneeChange(event: any) {
    const selectedUserId = event.value;
    if (Array.isArray(this.taskTagDataUserlist)) {
      const alreadyAssigned = this.taskTagDataUserlist.some((user: any) => user.userId === selectedUserId);
      if (alreadyAssigned) {
        this.leaderService.showNotification('This user is already assigned to the task.', true);
        this.reassignForm.get('attendeesIds')?.setValue('', { emitEvent: false });
      }
    }
  }

  createForm() {
    this.reassignForm = this.fb.group({
      attendeesIds: ['', Validators.required],
    });
  }

  getUserList() {
    this.isLoading = true;
    // Using dummy hospital ID (1) for now as requested
    const hospitalId = 1;

    this.leaderService.getAssignedUserDictionary(hospitalId).subscribe({
      next: (res: any) => {
        this.userList = res.data || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.leaderService.showNotification('Error loading user list.', true);
        this.isLoading = false;
      }
    });
  }

  onSave() {
    this.loading = true;

    if (this.reassignForm.valid) {
      const val = this.reassignForm.value;

      const attendeesIds = Array.isArray(val.attendeesIds)
        ? val.attendeesIds.map((u: any) => u && typeof u === 'object' && u.id !== undefined ? u.id : u)
        : [];
      let data = {
        taskId: this.data.taskId,
        userId: attendeesIds,
      };
      this.leaderService.postTaskTagUserlist(data).subscribe({
        next: () => {
          this.loading = false;
          this.leaderService.showNotification('Task New User Assigned successfully.', false);
          this.dialogRef.close({
            success: true,
            userId: attendeesIds,
          });
        },
        error: () => {
          this.leaderService.showNotification('Error assigning new user to task.', true);
          this.loading = false;
        }
      });
    } else {
      this.reassignForm.markAllAsTouched();
      this.leaderService.showNotification('Please select a user.', true);
      this.loading = false;
    }
  }

  // onSave() {
  //   if (this.reassignForm.valid) {
  //     const val = this.reassignForm.value;
  //     // Only pass a single userId, not an array
  //     let userId: any = val.attendeesIds;
  //     if (Array.isArray(userId)) {
  //       userId = userId.length > 0 ? (userId[0]?.id ?? userId[0]) : '';
  //     } else if (userId && typeof userId === 'object' && userId.id !== undefined) {
  //       userId = userId.id;
  //     }
  //     let data = [{
  //       taskId: this.data.taskId,
  //       userId: userId,
  //     }];
  //     this.leaderService.postTaskTagUserlist(data).subscribe({
  //       next: () => {
  //         this.leaderService.showNotification('Task New User Assigned successfully.', false);
  //         this.dialogRef.close({
  //           success: true,
  //           userId: userId,
  //         });
  //       },
  //       error: () => {
  //         this.leaderService.showNotification('Error assigning new user to task.', true);
  //       }
  //     });
  //   } else {
  //     this.reassignForm.markAllAsTouched();
  //     this.leaderService.showNotification('Please select a user.', true);
  //   }
  // }

  onCancel() {
    this.dialogRef.close({ success: false });
  }
  searchUserDataList = (searchText: string) => {
    return this.leaderService.searchUserDataList(searchText);
  };
}
